// extracted by mini-css-extract-plugin
module.exports = {"root":"root___1RB0J"};